import React from "react";

const ProgressBar = (props) => {
  const { bgcolor, completed } = props;

  const containerStyles = {
    position:'absolute',
    height: 19,
    width: "95%",
    left: '50px',
    top:'3px',
    // background: "rgb(208 213 215)",
    background: "white",
    borderRadius: '3px 5px 5px 3px',
    // border:'none',
    border: `2px double white`,
    // boxShadow: 'rgb(221 227 229) -1px 2px 13px 3px'
  };
 
  const numberWrap = {
    position: 'relative',
    width: `100%`,
    height: 25,
    // height: '100%',
    padding: '5px',
    color: 'white',
    background: bgcolor,
    borderRadius: '8px'
  }

  const numberStyles = {
    position:'absolute',
    top:'-4px',
    padding: "5px",
    color: "white",
    marginRight: "15px",
    marginBottom: "5px"
  }

  const fillerStyles = {
    height: "100%",
    width: `${completed}%`,
    background: bgcolor,
    transition: "width 1s ease-in-out",
    // borderRadius: "inherit",
    borderRadius: "0 20px 20px 0",
    // textAlign: "right",
    transition: "width 0.5s ease-in-out",
    // display: 'flex',
    // justifyContent:'end',
    // alignItems: 'center',
    position:'relative'
  };

  const labelStyles = {
    padding: "5px",
    color: "white",
    marginRight: "15px",
    marginBottom: "5px"
  };

  return (
    <div style={{display: completed !== 0 ? 'flex' : 'none', justifyContent:'center', alignItems:'center'}}>
      <div style={numberWrap}>
        <span style={{...numberStyles}}>{`${completed}%` }</span>
        <div style={{...containerStyles}}>
          <div style={{...fillerStyles}}>
            <span style={{...labelStyles,position:'absolute', top:'-8px', right:0}}>
              {/* {completed < 10 ? '' : completed > 99?'completed!':'progress'} */}
            </span>
          </div>
        </div>
      </div>
      {/* <span style={{marginLeft:5, fontSize:'20px', fontWeight:'bold'}}>{`${completed}%` }</span> */}
    </div>
  );
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/Course/ProgressBar.js